import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { quocTichApi } from "../../../api/category/quocTichApi";
import { eDmQuocTichActionIds } from "../../action-types/category/IDmQuocTichActions";

export function* quocTichSaga(): any {
  yield takeLatest(eDmQuocTichActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(quocTichApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.quocTich.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.quocTich.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
